<template>
    <div>

            <DxForm :form-data="formData" :col-count="2"  validation-group="customerData">

                <DxSimpleItem :col-span="2" >
                    <template #default>
                        <div>
                            <span style="font-size: 24px">产品设置</span>
                        </div>
                    </template>
                </DxSimpleItem>

                <DxSimpleItem data-field="wechatName" >
                    <DxLabel text="公众号" />
                    <template #default>
                        <div>
                            <DxSelectBox @value-changed="changeWechatBox" :data-source="wechatNameSelect"
                                         display-expr="appName" value-expr="appId"  value-change-event="keyup"/>
                        </div>
                    </template>
                </DxSimpleItem>

                <DxSimpleItem  data-field="modeId" v-if="type != 'birthday'">
                    <DxLabel text="模板" />
                    <template #default>
                        <div>
                            <DxSelectBox @value-changed="changeModeltBox" :data-source="modeSelect" display-expr="title"
                                         value-expr="template_id"  value-change-event="keyup"/>
                        </div>
                    </template>
                </DxSimpleItem>

                <DxSimpleItem data-field="marketingName" >
                    <DxLabel text="营销名称" />
                </DxSimpleItem>

                <DxSimpleItem data-field="infoUrl"   v-if="type != 'birthday'">
                    <DxLabel text="模板详情页面路径" />
                </DxSimpleItem>

                <DxSimpleItem data-field="UID"    >
                         <DxLabel text="客户标签选择" />
                    <template #default>
                           <div>
                             <el-select v-model="param.uid" multiple placeholder="请选择" style="width: 100%" @change="Label">
                               <el-option
                                   v-for="item in labelNameSelect"
                                   :key="item.id"
                                   :label="item.label"
                                   :value="item.id"
                                   :disabled="item.disabled"
                               >
                               </el-option>
                             </el-select>

                           </div>
                    </template>
                </DxSimpleItem>

              <DxSimpleItem>
                <DxLabel text="" />
              </DxSimpleItem>
<!--                <DxSimpleItem data-field="mount"   v-if="type != 'birthday'">-->
<!--                    <DxLabel text="定价金额" />-->
<!--                    <template #default>-->
<!--                       <div>-->
<!--                           <DxNumberBox  v-model:value="mount"  format="#,##0.00￥"/>-->
<!--                       </div>-->
<!--                    </template>-->
<!--                </DxSimpleItem>-->

                <DxSimpleItem :col-span="2" >
                    <template #default>
                        <div>
                            <span style="font-size: 24px">推送频率设置</span>
                        </div>
                    </template>
                </DxSimpleItem>
                <!--推送周期start-->
                <DxSimpleItem  v-if="type != 'birthday'" data-field="startTime" :col-span="1" editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm:ss'}" >
                    <DxLabel text="活动开始时间" />
                </DxSimpleItem>

                <DxSimpleItem  v-if="type != 'birthday'" data-field="endTime" :col-span="1"  editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm:ss'}">
                    <DxLabel text="活动结束时间" />
                </DxSimpleItem>


                <DxSimpleItem  v-if="type != 'birthday'" data-field="transmitFre"  :col-span="1" >
                    <DxLabel text="推送周期" />
                    <template #default>
                        <div>
                            <DxTagBox :items="activityCycleNumber" displayExpr="text" valueExpr="value" :show-selection-controls="true" :search-enabled="true" palceholder="请选择"
                                      value-change-event="keyup" @value-changed="changeNumberBox"/>
                        </div>
                    </template>
                </DxSimpleItem>

                <DxSimpleItem v-if="type != 'birthday'" data-field="transmitTime" :col-span="1"  editor-type="dxDateBox" :editor-options="{type: 'time', displayFormat: 'HH:mm:ss'}" >
                    <DxLabel text="推送时间" />
                </DxSimpleItem>
                <!--推送周期end-->
                <DxSimpleItem :col-span="2" >
                    <template #default>
                        <div>
                            <span style="font-size: 24px">模板内容设置</span>
                        </div>
                    </template>
                </DxSimpleItem>
            </DxForm>
<!--             <div>-->
<!--                <DxForm  :col-count="2"  >-->
<!--                 <DxSimpleItem data-field="details"   v-if="type != 'birthday'" :col-span="2">-->
<!--                     <DxLabel text="消息市场页面详情介绍" />-->
<!--                     <template #default>-->
<!--                         <div>-->
<!--                             <DxTextArea :height="100" v-model:value="details"/>-->
<!--                         </div>-->
<!--                     </template>-->
<!--                 </DxSimpleItem>-->

<!--                 </DxForm>-->
<!--             </div>-->
            <div>
                <!--                        <div>{{modeMap}}</div>-->
                <DxForm  :col-count="2" :form-data="formData2"  >
                    <DxGroupItem  v-for="(mode,index) in modeMap" :key="index" >
                        <DxSimpleItem :data-field="mode.itemValue">
                            <DxLabel :text="mode.itemName" />
                        </DxSimpleItem>
                    </DxGroupItem>
                </DxForm>
            </div>


      <div align="center" style="margin-top: 50px">
        <DxButton @click="submitFrom" text="提交" type="success" />
        &nbsp;
        <DxButton  type="danger" :use-submit-behavior="true" @click="$emit('close')" text="关闭"/>
      </div>
    </div>
</template>

<script>
    import {activityCycle_number} from "@/js/data";
    import CustomStore from "devextreme/data/custom_store";
    export default {
        /*营销列表*/
        name: "marketingAdd",
        data(){
            return{
                type:"list",
                formData:{},
                wechatNameSelect:[],
                labelNameSelect:[],
                modeSelect:[],
                files: [],
                marketingType:new Object(),
                wxId:new Object(),
                activity:{},
                modeMap:[],
                positionOptions:[],
                formData2:{},
                param:{},
                activityCycleNumber: activityCycle_number,
                gridDataSource: [],
                gridBoxValue: [],
                gridColumns: ['headImgUrl','fromUserName', 'nickName', 'phone'],
                selectionChanged: (data) => {
                    this.gridBoxValue=[]
                    for(var i=0;i<data.selectedRowsData.length;i++){
                        this.gridBoxValue[i] = data.selectedRowsData[i].id
                    }
                },
                mount:0,
                details:""
            }
        },
        created() {
            this.init()
        },
        computed: {
            companySelectorLabelMode() {
                if (this.labelMode === 'outside') {
                    return 'hidden';
                }
                return this.labelMode;
            },
        },
        methods:{
          /*获取微信公众号信息*/
          init: async function(){
            this.$http.get_wxconfig(null).then(res=>{
              this.wechatNameSelect = res.data
            })
          },

          //选择微信公众号获取模板和标签
          changeWechatBox(e){
            //获取标签
            this.LabelStatistics(e.value)
            this.param.wxId = e.value
            this.param.wechatId=e.value
            //根据微信公众号获取所有的模板
            this.$http.get_template_all({"appId":e.value}).then(res =>{
              if(res.status == "success"){
                if(this.type == "birthday"){
                  this.modeSelect =res.data.filter(item => item.title.indexOf("生日") > -1 && item.title !== "订阅模板消息")
                  this.transFormMap(this.modeSelect[0].content)
                  this.param.modeId=  this.modeSelect[0].template_id
                  this.param.marketingType = 1
                }else{
                  this.modeSelect =res.data.filter(item => item.title.indexOf("生日") == -1 && item.title !== "订阅模板消息")
                }
                this.$message({type: 'success', message:'获取当前公众号模板成功', center: true});
              }else {
                this.$message({type: 'error', message:'获取当前公众号模板异常', center: true});
              }


            })
            if(this.type == "list"){
              //用户标签
              this.$http.get_all_tags_pu({"appId":e.value}).then( res=>{
                this.positionOptions = res.data
              })
            }

          },
          LabelStatistics(e){
                this.$http.LabelStatistics({wxId:e}).then(res => {
                  this.labelNameSelect = res.data.map((item)=>{
                    return {
                      ...item, // 复制原始对象的属性
                      label: item.text + "(" + item.total + ")" // 添加新属性label
                    };
                  })
                })
          },
          Label(e){
            if(e.length==0){
              this.labelNameSelect.map((item) => {
                item.disabled=false
              })
            }else {
              //
              // 判断集合中是否包含 "全部",并且只选择了一条
              const hasBanana = e.includes("0");
              if(hasBanana &&  e.length==1){
                this.labelNameSelect.map((item)=>{
                  if(item.id!="0"){
                    item.disabled=true
                  }
                })
              }

              if(!hasBanana &&  e.length>=1){
                this.labelNameSelect.map((item)=>{
                  if(item.id=="0"){
                    item.disabled=true
                  }
                })
              }

            }
          },
            //把数据处理成下拉表格的模式
            makeAsyncDataSource(json) {
                    return new CustomStore({
                        loadMode: 'raw',
                        key: 'id',
                        load() {
                            return json;
                        },
                    });
            },


            changeModeltBox(e){
                this.param.modeId=e.value
                //获取模板详情
                this.$http.get_model_info({"appId":this.param.wechatId,"modelId":e.value}).then(res=> {
                    this.modeMap = []
                    if (res.status == "success") {
                        let modelMap = res.data[0].content
                        this.transFormMap(modelMap)
                    }
                })
            },
            transFormMap(modelMap){
                for (let key in modelMap) {
                  if(key!=" " && key!="\n "){
                    let temp = {
                      "itemValue": modelMap[key],
                      "itemName": key==" "?modelMap[key]:key
                    }
                    this.modeMap.push(temp)
                  }

                }

            },
             hasMultiline(text) {
               const regex = /^[\n\r]+$/;
               return regex.test(text);
              },
            submitFrom: async function(){
                     //数据校验
                    if(this.param.wxId == null || this.param.wxId == undefined){
                      this.$message({type: 'warning', message:'请选择公众号', center: true});
                      return ;
                    }
                    if(this.param.modeId == null || this.param.modeId == undefined){
                      this.$message({type: 'warning', message:'请选择推送模板', center: true});
                      return ;
                    }
                    if(this.formData.marketingName == undefined || this.formData.marketingName == undefined){
                      this.$message({type: 'warning', message:'营销活动名称必填', center: true});
                      return ;
                    }
                    if(this.param.uid.length==0){
                      this.$message({type: 'warning', message:'请选择用户标签', center: true});
                      return ;
                    }
                    if(this.formData.startTime == undefined || this.formData.endTime == undefined){
                      this.$message({type: 'warning', message:'活动时间必填', center: true});
                        return ;
                    }
                    if(new Date(this.formData.startTime).getTime() >= new Date(this.formData.endTime).getTime()){
                      this.$message({type: 'warning', message:'开始时间不能大于等于结束时间', center: true});
                        return ;
                    }
                    if(this.transmitFre==undefined || this.transmitFre==null || this.transmitFre.length==0){
                      this.$message({type: 'warning', message:'请选择推送周期', center: true});
                      return ;
                    }
                    if(this.formData.transmitTime==undefined || this.formData.transmitTime==null ){
                      this.$message({type: 'warning', message:'请选择推送时间', center: true});
                      return ;
                    }

                //数据提交
                this.loading = true;
                this.param.startTime = this.formatDate(this.formData.startTime)
                this.param.endTime =  this.formatDate(this.formData.endTime)
                this.param.transmitTime = this.getTime(this.formData.transmitTime)
                this.param.transmitFre =  JSON.stringify(this.transmitFre)
                this.param.marketingName = this.formData.marketingName
                this.param.infoUrl= this.formData.infoUrl
                this.param.sendConnet = this.formData2
                this.param.mount=this.mount
                this.param.details=this.details
                this.param.uidStr=JSON.parse(JSON.stringify(this.param.uid.toString()))
                let that = this
                this.$http.send_activity_message(this.param).then(res =>{
                    if(res.status == "success"){
                        this.close()
                        this.$emit('refresh')
                      this.$message({type: 'success', message:res.msg, center: true});
                    }else {
                      this.$message({type: 'error', message:res.msg, center: true});
                    }
                    that.param = []
                    that.formData = []
                    that.formData2 = []
                    this.modeMap = []
                    this.modeSelect = []
                    this.positionOptions = []
                })

            },
            close(){
                Object.keys(this.formData).forEach(key => (this.formData[key] = ''));
                this.$emit('close');
            },
            changeNumberBox(e){
                this.transmitFre = e.value
            },
            formatDate(date) {
                var date = new Date(date)
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen (month) + "-" + this.formatTen (day)+ " " +this.formatTen (hour)+ ":" +this.formatTen (minute)+ ":" +this.formatTen (second);
            },
            getTime(date){
                var date = new Date(date)
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return this.formatTen (hour)+ ":" +this.formatTen (minute)+ ":" +this.formatTen (second);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
        }
    };
</script>

<style scoped>

</style>